module.exports = __webpack_public_path__ + "img/59.36f395d7.jpg";